export const HELLO_WORLD = 'HELLO_WORLD';

export const INTRO_NEXT = 'INTRO_NEXT';
export const INTRO_PREV = 'INTRO_PREV';
export const INTRO_SKIP = 'INTRO_SKIP';

export const START_APP = 'START_APP';

export const OPEN_STAR_INFO = 'OPEN_STAR_INFO';

export const CLOSE_MODAL = 'CLOSE_MODAL';
